import { URL } from "../utils/constants.ts";

export async function getCategories() {
  let url = URL + "/Category/category";

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the categories.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const categories = await response.json();

  return categories;
}

export async function getFilamentTypes() {
  let url = URL + "/Filament/types";

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the filament types."
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();

  return data.map((type) => {
    return {
      id: type.typeID,
      value: type.typeName,
      label: type.typeName,
    };
  });
}

export async function getColors() {
  let url = URL + "/Filament/colors";

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the colors.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();
  return data.map((type) => {
    return {
      label: type.colorName,
      value: type.colorCode,
    };
  });
}

export async function getProductByCategory(categoryName) {
  let url = URL + "/Produse/category";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
    body: JSON.stringify({ name: categoryName }),
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the filament types."
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();

  return data;
}
export async function getProductByCategoryId(categoryId) {
  let url = URL + "/Produse/categoryId/" + categoryId;
  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the filament types."
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();

  return data;
}
export async function getSearchProducts(searchTerm) {
  let url = URL + "/Produse/Nume/" + searchTerm;
  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the filament types."
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();

  return data;
}

export async function getProductDetails(productId) {
  let url = URL + "/Produse/" + productId;
  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the product details."
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();

  return data;
}

export async function getTechnicProductDetails(productId) {
  let url = URL + "/Produse/technicProduct/" + productId;
  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the product details."
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();

  return data;
}

export async function getProductReviews(productId) {
  let url = URL + "/Review/" + productId;
  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the product details."
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();

  return data;
}

export async function addReview(review, token) {
  const url = URL + "/Review";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(review),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating review.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export const uploadImage = async (file, productId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("productId", productId);

  const response = await fetch(URL + "/Produse/image", {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating review.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
};

export const updateImage = async (file, imageId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("imageId", imageId);

  const response = await fetch(URL + "/Produse/update-image", {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating review.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
};
export async function addNewCategory(category) {
  const url = URL + "/Category";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
    body: JSON.stringify(category),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating filament.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function updateProductData(
  productId,
  isListed,
  price,
  discount,
  stock,
  token
) {
  const url =
    URL +
    `/Produse/${productId}?isListed=${isListed}&price=${price}&discount=${discount}&stock=${stock}`;

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the product details."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }
}

export async function addNewProduct(product, token) {
  const url = URL + "/Produse";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
      // Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(product),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating filament.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}
